import React from 'react';
import classnames from 'classnames';

import styles from './navbar-sublevel.module.scss';

type NavBarSubLevelItemProps = {
  selected?: boolean;
  children: string;
  href: string;
} & Pick<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'title' | 'rel' | 'onClick'>;

export type NavBarSubLevelProps = { items: NavBarSubLevelItemProps[]; variant: 'default' | 'headline' } & Pick<
  React.HTMLAttributes<HTMLDivElement>,
  'className'
>;

const baseClass = 'navbar-sublevel';

export const NavBarSubLevel: React.FC<NavBarSubLevelProps> = ({ items, variant, className }) => {
  const classes = classnames(styles[baseClass], styles[`${baseClass}--${variant}`], className);

  return (
    <nav className={classes} data-testid="navbar-sublevel-component">
      <ul className={styles[`${baseClass}__list`]}>
        {items.map((item, i) => {
          const itemClasses = classnames(styles[`${baseClass}__item`], {
            [styles[`${baseClass}__item--selected`]]: item.selected
          });
          return (
            <li key={item.children + i} className={itemClasses}>
              <a {...item} className={styles[`${baseClass}__link`]}>
                {item.children}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
